import StorageHelper from '../../helper';

const scope = 'CAMPAIGNS/forms';

const mod = {
  namespaced: true,
  state: {
    addressAutocomplete: {},
    advocateCreatePayload: {},
    advocateRecord: {},
    actionError: '',
    cookieBadgeVisible: false,
    cookieBadgeConvoVisible: false,
    completedOptions: {
      subscribeEmail: false,
      subscribeSms: false
    },
    error: "",
    formValues: {
      subscribeEmail: true,
      subscribeSms: true,
      postOnOwnWall: true,
      shareWithFollowers: true,
    },
    frozenFormValues: {},
    honeypotPageLoadTime: null,
    customFields: {},
    validationResults: {},
    started: false,
    needAdditionalFields: {
      email: false,
      facebook: false,
      twitter: false,
      call: false,
      'default': false,
    },
    titleDefaultSelected: true
  },
  mutations: {
    advocateCreatePayload: (state, advocateCreatePayloadObject) => {
      state.advocateCreatePayload = advocateCreatePayloadObject
    },
    advocateRecord: (state, advocateRecordObject) => {
      state.advocateRecord = advocateRecordObject
    },
    addressAutocomplete: (state, addressObject) => {
      state.addressAutocomplete = addressObject
    },
    actionError: (state, actionError) => {
      state.actionError = actionError;
    },
    cookieBadgeVisible: (state, bool) => {
      state.cookieBadgeVisible = bool
    },
    cookieBadgeConvoVisible: (state, bool) => {
      state.cookieBadgeConvoVisible = bool
    },
    completedOptions: (state, completedOptionsObject) => {
      state.completedOptions = { ...state.completedOptions, ...completedOptionsObject}
    },
    error: (state, error) => {
      state.error = error
    },
    formValues: (state, valuesObject) => {
      state.formValues = {
        ...state.formValues,
        [valuesObject.fieldName]: valuesObject.value,
      };
    },
    frozenFormValues: (state, frozenValues) => {
      state.frozenFormValues = {
        ...state.frozenFormValues,
        ...frozenValues
      }
    },
    honeypotPageLoadTime(state, value) {
      state.honeypotPageLoadTime = value;
    },
    needAdditionalFields: (state, needAdditionalFieldsObject) => {
        const currentAction = needAdditionalFieldsObject.action;
        state.needAdditionalFields = {
            ...state.needAdditionalFields,
            [currentAction]: needAdditionalFieldsObject.needAdditionalFields
        }
    },
    customFields: (state, customFields) => {
      state.customFields = {
        ...state.customFields,
        ...customFields
      };
    },
    validationResults: (state, validationResultsObject) => {
      const currentAction = validationResultsObject.action;
      const currentActionValidationResults = state.validationResults[currentAction] || {};

      currentActionValidationResults[validationResultsObject.fieldName] = validationResultsObject.value;

      state.validationResults = {
        ...state.validationResults,
        [currentAction]: currentActionValidationResults
      };
    },
    started: (state, started) => {
      state.started = Boolean(started);
    },
    titleDefaultSelected: (state, bool) => {
      state.titleDefaultSelected = bool
    }
  },
  actions: {
    advocateCreatePayload({ commit }, advocateCreatePayloadObject) {
      commit('advocateCreatePayload', advocateCreatePayloadObject)
    },
    advocateRecord({ commit }, advocateRecordObject) {
      commit('advocateRecord', advocateRecordObject)
    },
    addressAutocomplete({ commit }, addressObject) {
      commit('addressAutocomplete', addressObject)
    },
    actionError({ commit }, actionError) {
      commit('actionError', actionError);
    },
    completedOptions({ commit }, completedOptionsObject) {
      commit('completedOptions', completedOptionsObject)
    },
    cookieBadgeVisible({commit}, bool) {
      commit('cookieBadgeVisible', bool);
    },
    cookieBadgeConvoVisible({commit}, bool) {
      commit('cookieBadgeConvoVisible', bool);
    },
    error({ commit }, error) {
      commit('error', error);
    },
    formValues({ commit }, valuesObject) {
      StorageHelper.setLocalStorageVar(commit, valuesObject, 'formValues', scope);
    },
    frozenFormValues({commit}, frozenValues) {
      StorageHelper.setLocalStorageVar(commit, frozenValues, 'frozenFormValues', scope);
    },
    honeypotPageLoadTime({ commit }, value) {
      commit("honeypotPageLoadTime", value);
    },
    needAdditionalFields({ commit }, needAdditionalFieldsObject) {
      StorageHelper.setLocalStorageVar(commit, needAdditionalFieldsObject, 'needAdditionalFields', scope);
    },
    customFields({ commit }, customFields) {
      StorageHelper.setLocalStorageVar(commit, customFields, 'customFields', scope);
    },
    validationResults({ commit }, validationResultsObject) {
      StorageHelper.setLocalStorageVar(commit, validationResultsObject, 'validationResults', scope);
    },
    started({ commit }, started) {
      StorageHelper.setLocalStorageVar(commit, started, 'started', scope);
    },
    titleDefaultSelected({commit}, bool) {
      StorageHelper.setLocalStorageVar(commit, bool, 'titleDefaultSelected', scope);
    }
  },
  getters: {
    advocateCreatePayload(state) {
      return state.advocateCreatePayload;
    },
    addressAutocomplete(state) {
      return state.addressAutocomplete
    },
    advocateRecord(state) {
      return state.advocateRecord
    },
    actionError(state) {
      return state.actionError;
    },
    completedOptions(state) {
      return state.completedOptions
    },
    cookieBadgeVisible(state) {
      return state.cookieBadgeVisible
    },
    cookieBadgeConvoVisible(state) {
      return state.cookieBadgeConvoVisible
    },
    error(state) {
        return state.error;
    },
    formValues(state) {
      return state.formValues;
    },
    frozenFormValues(state) {
      return state.frozenFormValues;
    },
    needAdditionalFields(state) {
      return state.needAdditionalFields;
    },
    customFields(state) {
      return state.customFields;
    },
    validationResults(state) {
      return state.validationResults;
    },
    started(state) {
      return state.started;
    },
    titleDefaultSelected(state) {
      return state.titleDefaultSelected
    }
  },
};

export default mod;
